<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="currentSociety"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
          @change="changeSoc()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :cols="currentUser === undefined ? '12' : '6'"
        class="list-overflow"
      >
        <v-list>
          <v-list-item-group v-model="currentUser">
            <v-list-item
              v-for="user in usersData"
              :key="user.key"
            >
              <v-list-item-title>
                {{ user.login }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon v-if="user.id_usr == 0">mdi-account-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="currentUser !== undefined"
        cols="6"
      >
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="usersData[currentUser].login"
                :label="$t('profile.sections.user.login')"
                type="email"
                :rules="[rules.regex]"
                :append-icon="iconAvailable"
                dense
                :background-color="colorAvailable"
                @change="checkName()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="usersData[currentUser].password"
                :rules="[rules.required, rules.min]"
                :label="$t('profile.sections.user.password')"
                counter
                dense
                @click:append="show = !show"
              />
            </v-col>
            <v-col cols="2">
              <v-btn
                icon
                @click="randomPass()"
              >
                <v-icon>mdi-autorenew</v-icon>
              </v-btn>
              <v-btn
                icon
                @click="copy()"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="usersData[currentUser].name"
                :rules="[rules.required]"
                :label="$t('profile.sections.common.name')"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="usersData[currentUser].firstname"
                :rules="[rules.required]"
                :label="$t('profile.sections.user.firstname')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="usersData[currentUser].phone"
                :label="$t('profile.sections.user.phone')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="usersData[currentUser].access"
                :items="societyAccesses"
                :label="$t('profile.sections.user.access')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-btn
                color="primary"
                :disabled="usersData[currentUser].password.length < 8 || !nameAvailable || disableButton"
                @click="updateUserData()"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                color="primary"
                :disabled="usersData[currentUser].enable"
                @click="enableUser(usersData[currentUser].id_usr)"
              >
                <v-icon class="mr-2">mdi-account-sync</v-icon>{{ $t("profile.sections.common.enable") }}
              </v-btn>
            </v-col>
            <v-col cols="4">
              <button-dialog-delete
                :text="$t('popup.user')"
                :is-button-disabled="usersData.length <= 2 || disableButton"
                @ok-pushed="deleteUser(usersData[currentUser].id_usr)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../../Common/ButtonDialogDelete";

// Connectors
import { ProfileAccessConnector } from "../../Database/ProfileAccessConnector.js";
import { ProfileUserConnector } from "../../Database/ProfileUserConnector.js";
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

export default {
  components: {
    buttonDialogDelete,
  },
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      currentUser: undefined,
      usersData: [],
      accessesData: [],
      disableButton: false,
      show: false,
      currentSociety: 0,
      characters: "a-z,A-Z,0-9",
      size: 8,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
      socData: [],
      isDisabled: true,
      nameAvailable: true,
    };
  },
  computed: {
    iconAvailable() {
      if (this.nameAvailable) {
        return "mdi-check-circle";
      } else {
        return "mdi-close-circle";
      }
    },
    colorAvailable() {
      if (this.nameAvailable) {
        return "";
      } else {
        return "error";
      }
    },
    societyAccesses() {
      const result = this.accessesData.filter((access) => {
        return access.soc_id == this.usersData[this.currentUser].soc_id;
      });

      return result;
    },
  },
  created() {
    this.getListAccess();
    this.getUsersData();
    this.getSociety();
  },
  methods: {
    checkName() {
      this.societyConnector
        .checkDuplicate(31, this.usersData[this.currentUser].login, this.usersData[this.currentUser].id_usr)
        .then((isAvailable) => {
          this.nameAvailable = isAvailable;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    randomPass() {
      const charactersArray = this.characters.split(",");
      let characterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        characterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        characterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        characterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        characterSet += "!%&*$#@";
      }

      for (let i = 0; i < this.size; i++) {
        password += characterSet.charAt(Math.floor(Math.random() * characterSet.length));
      }

      this.usersData[this.currentUser].password = password;
    },
    copy() {
      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.usersData[this.currentUser].password).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", this.usersData[this.currentUser].password);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;

        // Add all on the top of list
        this.socData.unshift({ id_soc: 0, name: this.$t("dialog.all") });
      });
    },
    getListAccess() {
      this.accessConnector.getListAccess().then((response) => {
        // TODO: format in db server
        this.accessesData = response.map((data) => {
          return {
            value: data.id_right,
            text: data.name,
            soc_id: data.soc_id,
          };
        });
      });
    },
    getUsersData() {
      this.userConnector.getUsersData().then((users) => {
        // TODO: format in db server
        this.usersData = users.map((data) => {
          return {
            id_usr: data.id_usr,
            login: data.login,
            password: "",
            name: data.lastname,
            firstname: data.firstname,
            phone: data.phone,
            access: data.right_id,
            soc_id: data.soc_id,
            enable: data.enable,
          };
        });

        this.fullUser = this.usersData;
      });
    },
    updateUserData() {
      // Prevent double click on create
      this.disableButton = true;

      // Confirm last check of name available
      if (this.nameAvailable) {
        // Insert user in DB
        this.societyConnector
          .updateUser(this.usersData[this.currentUser])
          .then(() => {
            // Empty the password to prevent double click
            this.usersData[this.currentUser].password = "";
            this.currentUser = undefined;
          })
          .finally(() => {
            // Permit to reenable create button
            this.disableButton = false;
          });
      }
    },
    disableUser(uid) {
      if (uid > 0) {
        this.disableButton = true;

        this.userConnector
          .disableUserData(uid)
          .then(() => {
            this.usersData[this.currentUser].password = "";
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    deleteUser(uid) {
      if (uid > 0) {
        this.disableButton = true;

        this.userConnector
          .deleteUserData(uid)
          .then(() => {
            this.usersData.splice(this.currentUser, 1);
            this.currentUser = undefined;

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.delete-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.delete"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    enableUser(uid) {
      if (uid > 0 && this.usersData[this.currentUser].enable == 0) {
        this.userConnector
          .enableUserData(uid)
          .then(() => {
            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.user-enabled"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.error"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    changeSoc() {
      this.usersData = [];
      if (this.currentSociety == 0) {
        this.usersData = this.fullUser;
        return;
      }
      this.fullUser.forEach((element) => {
        if (element.soc_id == this.currentSociety) {
          this.usersData.push(element);
        }
      });
    },
  },
};
</script>

<style></style>
